import { createContext, useContext, useState } from "react";
import { AlertColor } from "@mui/material";

type SnackbarSetter = (active: boolean, message?: string, severity?: AlertColor) => void;

interface SnackbarState {
  active: boolean;
  message: string;
  severity: AlertColor;
  setSnackbar: SnackbarSetter;
  cancel: () => void;
}

const defaultState: SnackbarState = {
  active: false,
  message: "",
  severity: "success",
  setSnackbar: () => {},
  cancel: () => {},
};

export const SnackbarContext = createContext<SnackbarState>(defaultState);

export const useSnackbar = () => useContext(SnackbarContext);

export function SnackbarProvider({ children }: { children: React.ReactNode }) {
  const [message, setMessage] = useState("");
  const [active, setActive] = useState(false);
  const [severity, setSeverity] = useState<AlertColor>("success");

  const setSnackbar: SnackbarSetter = (isActive, message, severity) => {
    if (isActive) {
      if (message) setMessage(message);
      if (severity) setSeverity(severity);
    } else {
      setMessage("");
      setSeverity("success");
    }
    setActive(isActive);
  };

  const cancel = () => setActive(false);

  return (
    <SnackbarContext.Provider
      value={{ active, message, severity, setSnackbar, cancel }}
    >
      {children}
    </SnackbarContext.Provider>
  );
}
